import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

const BannerIconContainer = styled.div`
  padding-right: 24px;
  font-size: 48px;
`;

const BannerIcon = ({ children }) => (
  <BannerIconContainer>
    <span>{children}</span>
  </BannerIconContainer>
)

export default BannerIcon;
